/**
 * Único lugar que usa o armazenamento do navegador, e só para preferências de interface
 * (constituição III; docs/03). Dado do servidor e sessão nunca passam por aqui.
 */
export type Preferencia = 'menu-recolhido' | 'tema';

const PREFIXO = 'fit-web:';

export function lerPreferencia(chave: Preferencia): string | null {
  try {
    return localStorage.getItem(PREFIXO + chave);
  } catch {
    return null;
  }
}

export function gravarPreferencia(chave: Preferencia, valor: string): void {
  try {
    localStorage.setItem(PREFIXO + chave, valor);
  } catch {
    // Armazenamento bloqueado (janela privada): a preferência só não persiste.
  }
}
